module.exports = "/_next/static/images/eu-499ed29f13ca78d19c1cc4683b3be4bc.svg";